<template>
  <div v-if="hasAccess" class="generic-contents-shell">
    <PageSubmenu :links="links" />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageSubmenu from '@/components/PageSubmenu.vue'
import { INTERNAL_MEDIA_LABEL } from '@/utils/internalMediaLabel'

export default {
  name: 'app-dashboard-generic-contents',
  components: { PageSubmenu },
  computed: {
    ...mapGetters(['roles']),
    hasAccess () {
      return this.roles.some(role => ['admin', 'community-manager'].includes(role))
    },
    links () {
      return [
        {
          label: INTERNAL_MEDIA_LABEL,
          path: '/app/dashboard/tracking/generic-contents/media',
          roles: ['admin', 'community-manager']
        },
        {
          label: 'FAQ Code du travail',
          path: '/app/dashboard/tracking/generic-contents/faq/questions',
          activePrefix: '/app/dashboard/tracking/generic-contents/faq',
          roles: ['admin', 'community-manager']
        }
      ]
    }
  }
}
</script>

<style scoped>
.generic-contents-shell {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 64px);
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  width: 100%;
}
.generic-contents-shell > :first-child { flex: 0 0 auto; }
.generic-contents-shell > :last-child {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}
</style>
